// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1j_fv","options":"AnswerScale_options__3Xx_j","selected":"AnswerScale_selected__3NPmW"};